import client from '@/services/';

const state = () => ({
    uploadedFile: null,
    uploadedFichier: null,
    all: [],
});

const getters = {
    uploadedFile: state => state.uploadedFile,
    uploadedFichier: state => state.uploadedFichier,
    all: state => state.all,

};

const mutations = {
    SET_UPLOADED_FILE: (state, form) => {
        state.uploadedFile = form;
    },
    SET_UPLOADED_FICHIER: (state, form) => {
        state.uploadedFichier = form;
    },
    SET_ALL: (state, obj) => {
        state.all = obj;
    },
};

const actions = {
    async uploadFichier({ commit }, { idSousCategorie, fileData }) {
        const { data } = await client.post(
            `/importation/utilisateurs/${idSousCategorie}`,
            fileData, 
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        commit('SET_UPLOADED_FILE', data);
        return data;
    },
    async getAll({ commit }, params = {}) {
        const { page = 0, size = 10, sort = '', nom, prenom, matriculeAncien, matricule, email, libelle, type, sousCode, sousLibelle, after, before } = params;
        const queryParams = new URLSearchParams({
            page,
            size,
            sort,
            ...(nom && { nom }),
            ...(prenom && { prenom }),
            ...(matriculeAncien && { matriculeAncien }),
            ...(matricule && { matricule }),
            ...(email && { email }),
            ...(libelle && { libelle }),
            ...(type && { type }),
            ...(sousCode && { sousCode }),
            ...(sousLibelle && { sousLibelle }),
            ...(after && { after }),
            ...(before && { before }),
        }).toString();
        let data = await client.get(`/importation?${queryParams}`);
        commit("SET_ALL", data.data);
        return data.data;
    },
    async uploadFichierSociete({ commit }, { idSousCategorie, fileData }) {
        const { data } = await client.post(
            `/importation/societes/${idSousCategorie}`,
            fileData, 
            {
                headers: { 'Content-Type': 'multipart/form-data' },
            }
        );
        commit('SET_UPLOADED_FILE', data);
        return data;
    },
    async receiveNotification(_, payload) {
        try {
            console.log('Payload reçu dans Vuex :', payload); // Vérifiez que c'est bien un tableau brut
            await client.post('/importation/create/demande/notify', payload);
        } catch (error) {
            console.error('Erreur dans receiveNotification Vuex :', error);
            throw error;
        }
    }
    
    
    

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};